import { render, staticRenderFns } from "./develop_manage.vue?vue&type=template&id=6608cea4&scoped=true&"
import script from "./develop_manage.vue?vue&type=script&lang=js&"
export * from "./develop_manage.vue?vue&type=script&lang=js&"
import style0 from "./develop_manage.vue?vue&type=style&index=0&id=6608cea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6608cea4",
  null
  
)

export default component.exports